import CourseList1 from "./CourseList1";

const courseLists = {
    1: CourseList1
};

export default courseLists;